import { render, staticRenderFns } from "./PriceConfigRow.vue?vue&type=template&id=629513a0&"
import script from "./PriceConfigRow.vue?vue&type=script&lang=ts&"
export * from "./PriceConfigRow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports